<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PieRevenueSegment from './charts/pie-revenue-segment.vue'
import PieRevenueWitel from './charts/pie-revenue-witel.vue'
import PiePanjar from './charts/pie-panjar.vue'
import PieJps from './charts/pie-jps.vue'
import StackedOutlook from './charts/stacked-outlook.vue'

export default {
  page: {
    title: 'Starter',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PieRevenueSegment,
    PieRevenueWitel,
    PiePanjar,
    PieJps,
    StackedOutlook,
  },
  data() {
    return {
      title: 'Starter',
      items: [
        {
          text: 'Shreyu',
          href: '/',
        },
        {
          text: 'Pages',
          href: '/',
        },
        {
          text: 'Starter',
          active: true,
        },
      ],
    }
  },
}
</script>

<template>
  <Layout>
    <pie-revenue-segment />
    <pie-revenue-witel />
    <div class="row">
      <pie-panjar />
      <pie-jps />
    </div>
    <stacked-outlook />
  </Layout>
</template>
